
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ideje/[category_or_location]",
      function () {
        return require("private-next-pages/ideje/[category_or_location]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ideje/[category_or_location]"])
      });
    }
  